// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6d9664ab","547":"e910bef6"}[chunkId] + ".chunk.js";
};